import {useQuery} from '@apollo/react-hooks';

import type {
    GetLeadChannels as GetLeadChannelsQuery,
    GetLeadChannelsVariables as GetLeadChannelsQueryVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_CHANNELS from '../graphql/queries/get-lead-channels.graphql';

export const useGetLeadChannels = (leadId: string) => {
    const {data, refetch, loading} = useQuery<GetLeadChannelsQuery, GetLeadChannelsQueryVariables>(
        GET_LEAD_CHANNELS,
        {
            variables: {id: leadId},
            fetchPolicy: 'cache-and-network',
        }
    );

    const lead = data ? data.lead : null;

    return {
        channels: lead && lead.channels && lead.channels.edges ? lead.channels.edges : [],
        additionalSources:
            lead && lead.channels && lead.channels.sources ? lead.channels.sources : [],
        refetch,
        isLoading: loading,
    };
};
